export const RATINGS_FIXED = 'ratings_fixed';

export const iconsList = [
  { id: 'eyes', label: 'Eyes' },
  { id: 'faces_1', label: 'Faces 1' },
  { id: 'faces_2', label: 'Faces 2' },
  { id: 'flowers', label: 'Flowers' },
  { id: 'gas_tank', label: 'Gas Tank' },
  { id: 'generation', label: 'Generation' },
  { id: 'glasses_of_water', label: 'Glasses of Water' },
  { id: 'growing_wheels', label: 'Growing Wheels' },
  { id: 'hands', label: 'Hands' },
  { id: 'hearts_gradient', label: 'Hearts Gradient' },
  { id: 'hurdles', label: 'Hurdles' },
  { id: 'ice_cream_emoji', label: 'Ice Cream Emoji' },
  { id: 'mad_happy_emoji', label: 'Mad Happy Emoji' },
  { id: 'magnifying_glass', label: 'Magnifying Glass' },
  { id: 'mood_weather', label: 'Mood Weather' },
  { id: 'office', label: 'Office' },
  { id: 'overwhelmed_happy_emoji', label: 'Overwhelmed Happy Emoji' },
  { id: 'pizza', label: 'Pizza' },
  { id: 'poo_emoji', label: 'Poo Emoji' },
  { id: 'rockets', label: 'Rockets' },
  { id: 'sad_happy_emoji', label: 'Sad Happy Emoji' },
  { id: 'stairs', label: 'Stairs' },
  { id: 'teal_rose', label: 'Teal Rose' },
  { id: 'technology', label: 'Technology' },
  { id: 'thumbs_rotating', label: 'Thumbs Rotating' },
  { id: 'trophies', label: 'Trophies' },
  { id: 'type_of_work', label: 'Type of Work' },
  { id: 'workplace_flexibility', label: 'Workplace Flex' },
];
